import MallItemDialogSelector from './mallitem-dialog-selector.vue'

MallItemDialogSelector.install = function (Vue) {
	Vue.component(MallItemDialogSelector.name, MallItemDialogSelector);
}

export default MallItemDialogSelector;